import * as React from 'react'
import UIMessages from '../../../../utils/ui-messages'
import Modal from '../../../ui/Modal'
import { MoonLoader } from 'react-spinners'

export interface IDeleteHotspotProps {
  onClose: () => void
  onDelete: () => void
  message?: string
  isDeleting?: boolean
}

class DeleteHotspotModal extends React.Component<IDeleteHotspotProps> {
  constructor(props: IDeleteHotspotProps) {
    super(props)
  }

  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='font-grey3 h5'>{this.props.message}</span>
            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={this.props.onClose}
                className='CancelButton btn bg-white rounded font-light-grey mr2'
              >
                {UIMessages.common.cancel}
              </button>
              <button
                type='button'
                onClick={this.props.onDelete}
                className='SubmitButton btn bg-red rounded font-white weight-300 w82'
              >
                {!this.props.isDeleting && UIMessages.common.deleteLabel}
                {this.props.isDeleting && (
                  <span className='flex items-center justify-center'>
                    <MoonLoader sizeUnit={'px'} size={13} color={'#FFFFFF'} loading={true} />
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default DeleteHotspotModal



// WEBPACK FOOTER //
// ./src/components/services/edit/modal/DeleteHotspotModal.tsx